import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from '@mui/material'
import ProductModal from '../../components/ProductModal'
import { CancelIcon } from '../../../../components/svgs/Svgs'
import { AndroidButton } from '../../../../components/common/AndroidButton'
import { AppStoreButton } from '../../../../components/common/AppStoreButton'

export function BusinessCard({ data }) {
    const [open, setOpen] = useState(false)
    const { img, title, text, demo, id, off, video, android, ios } = data
    const { t } = useTranslation()

    return (
        <div className="flex flex-col gap-[20px] w-auto h-auto group relative">
            {/* Image Container */}
            <div className={`relative w-auto h-[265px] overflow-hidden ${img === null ? 'bg-[#F4F4F4] '
                + 'dark:bg-[#515151]' : ''}`}
            >
                {img && (
                    <>
                        {/* Image itself */}
                        <img
                            src={img}
                            loading="lazy"
                            alt="img of the mine"
                            className={`w-full h-full object-cover transition duration-300 ${video
                                ? 'group-hover:blur-[4px]' : ''}`}
                        />
                        {/* Watch Button */}
                        {video && (
                            <button
                                onClick={() => setOpen(true)}
                                className="absolute inset-0 flex items-center justify-center
                                opacity-0 group-hover:opacity-100
                                transition duration-300"
                            >
                                <span className="bg-transparent border hover:bg-white hover:text-black transition-all
                                duration-500 ease-in-out
                                 border-white text-white px-[20px] py-[10px] rounded-[10px]"
                                >
                                    Tutorial
                                </span>
                            </button>
                        )}
                    </>
                )}
            </div>

            {/* Texts and Buttons */}
            <div className="flex flex-col items-start gap-[10px]">
                <div className="flex flex-col items-start gap-[6px]">
                    <span className="lg:text-[25px] sm:text-[18px] font-bold text-black dark:text-white">{title}</span>
                    <span className="lg:text-[18px] sm:text-[14px] font-normal text-[#525252] dark:text-white">
                        {text}
                    </span>
                </div>

                <div className="flex flex-row gap-[10px]">
                    {!off && <ProductModal id={id} />}
                    {demo && (
                        <button
                            type="button"
                            className="px-[25px] py-[10px] border border-[#0068B5] hover:bg-transparent
                             hover:text-[#0068B5] dark:text-black dark:bg-white dark:hover:bg-transparent
                             dark:hover:text-white dark:border-white transition-all duration-500 bg-[#0068B5]
                              text-white"
                            onClick={() => window.open(demo, '_blank')}
                        >
                            {t('btn.demo')}
                        </button>
                    )}
                </div>

                <div className="flex items-center gap-[20px]">
                    {android && <AndroidButton link={android} />}
                    {ios && <AppStoreButton link={ios} />}
                </div>
            </div>

            {/* Modal */}
            {video && (
                <Modal open={open} onClose={() => setOpen(false)}>
                    <div className="fixed inset-0 flex items-center justify-center p-4">
                        <div className="bg-white relative dark:bg-[#1e1e1e] p-4 rounded-xl max-w-[90%]
                         max-h-[90%] w-[800px] h-[350px] md:h-[450px] shadow-lg"
                        >
                            <video controls className="w-full h-full rounded-lg">
                                <source src={video} />
                                <track kind="captions" />
                            </video>
                            <div
                                onClick={() => setOpen(false)}
                                className="p-[17.5px] absolute top-[-60px] left-0 xl:top-0 xl:left-[-60px]
                                cursor-pointer bg-[#F7F7F7] rounded-[34px]"
                            >
                                <CancelIcon />
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    )
}
